import BasePage from "./BasePage";
import Link from "next/link";
import { useLocale } from "../../i18n/LocaleContext";
import { richText } from "../../i18n/runtime";
import { localePath } from "../../i18n/config";

const SUPPORT_EMAIL = "support@pokegrid.net";

function PagePrivacyPolicy() {
  const { messages, t } = useLocale();

  const email = (
    <a
      className="text-blue-600 underline dark:text-blue-400"
      href={`mailto:${SUPPORT_EMAIL}`}
    >
      {SUPPORT_EMAIL}
    </a>
  );

  return (
    <BasePage>
      <main className="mx-auto min-h-[34.625rem] max-w-screen-lg bg-slate-100  px-4 py-8 text-left sm:min-h-[41.375rem] sm:px-6 md:min-h-[52.5625rem]">
        <Breadcrumbs />
        <div className="max-w-screen-sm rounded-lg bg-white p-6 text-sm leading-relaxed">
          <h1 className="mb-4 text-xl font-semibold">{t("privacy.title")}</h1>
          {messages["privacy.blocks"].map((block, i) =>
            block.h2 ? (
              <h2 key={i} className="mb-4 mt-6 text-xl font-semibold">
                {block.h2}
              </h2>
            ) : block.ul ? (
              <ul key={i}>
                {block.ul.map((item) => (
                  <li key={item} className="mb-4 list-inside list-disc">
                    {item}
                  </li>
                ))}
              </ul>
            ) : (
              <p key={i} className="mb-4">
                {richText(block.p, { email })}
              </p>
            )
          )}
        </div>
      </main>
    </BasePage>
  );
}
export default PagePrivacyPolicy;

function Breadcrumbs() {
  const { locale, t } = useLocale();

  return (
    <nav className="mb-4 flex px-2" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 rtl:space-x-reverse md:space-x-2">
        <li className="inline-flex items-center">
          <Link href={localePath(locale, "/")} passHref>
            <a className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-red-600 dark:text-gray-400 dark:hover:text-white">
              <svg
                className="me-2.5 h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
              </svg>
              PokeGrid
            </a>
          </Link>
        </li>
        <li aria-current="page">
          <div className="flex items-center">
            <svg
              className="mx-1 h-3 w-3 text-gray-400 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="m1 9 4-4-4-4"
              />
            </svg>
            <span className="ms-1 text-sm font-medium text-gray-500 dark:text-gray-400 md:ms-2">
              {t("privacy.title")}
            </span>
          </div>
        </li>
      </ol>
    </nav>
  );
}
